import { Checkbox } from '@app/components/various/Fields/Checkbox';
import React from 'react';
import { useTranslation } from 'react-i18next';
interface Props {
  checked: boolean;
  disabled: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}
export const CheckboxCell = ({ onChange, checked }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <Checkbox className="z-interactiveTableItem after:absolute after:-inset-4" isChecked={checked} onChange={onChange}>
      <span className="sr-only">{t('common:select_row')}</span>
    </Checkbox>
  );
};
